import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { DataLakeBackends } from "@graylog/enterprise-api";
import { DATA_LAKE_CONFIG_QUERY_KEYS } from "data-lake/Constants";
const fetchDataLakeBackend = (id) => DataLakeBackends.getConfig(id);
const useDataLakeBackend = (id, enabled = true) => {
  const { data, refetch, isInitialLoading, isSuccess, error } = useQuery({
    queryKey: [...DATA_LAKE_CONFIG_QUERY_KEYS, id],
    queryFn: () => fetchDataLakeBackend(id),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data,
    refetch,
    isInitialLoading,
    isSuccess,
    error
  };
};
export default useDataLakeBackend;
